module.exports = __webpack_public_path__ + "static/media/suhas.8fc0a8b5.png";